import { get, post, download } from 'services/api-client';

const labcorpService = {
  generateFinalReport: (data) => post(`/labcorp/generate`, data),

  getLabcorpResult: (reportId) => get(`/labcorp/report/${reportId}`),

  downloadLabcorpResult: (reportId) => download(`/labcorp/download/labcorp-result?reportId=${reportId}`, "labcorp-result.pdf")
}

export default labcorpService;